import { Link } from 'react-router-dom'

import { CertificateIcon } from 'assets/icons/certificate'

import type { IZaiHeroTitleViewProps } from './zai-hero-title.types'

import './zai-hero-title.styles.scss'

export const ZaiHeroTitleView = ({
  brandDisplay,
  titleParts,
  fallbackTitle,
  userName,
  onBrandLinkClick,
}: IZaiHeroTitleViewProps) => (
  <h2 className="zai-hero-title">
    {brandDisplay && titleParts ? (
      <>
        {titleParts.before}
        {brandDisplay.url ? (
          <Link
            to={brandDisplay.url}
            className="zai-hero-title-brand-link"
            onClick={() => onBrandLinkClick(brandDisplay.name)}
          >
            {brandDisplay.name}
          </Link>
        ) : (
          brandDisplay.name
        )}
        {brandDisplay.isVerified && <CertificateIcon className="zai-hero-title-verified-icon" aria-label="Verified" />}
        {titleParts.after}
      </>
    ) : (
      fallbackTitle
    )}
    , {userName}
  </h2>
)
